/**
 * Navy-and-gold AntD theme for the MUAA admin — replaces RefineThemes.Blue.
 * Maps the delivered design tokens (brand.ts) onto AntD's ConfigProvider so the
 * whole panel re-skins at once: gold primary with navy button text, paper page
 * background, brand fonts, gold-accented menu selection, and the card/table/tag
 * treatment from the mock. The bespoke navy crest sidebar + header land next.
 */
import type { ThemeConfig } from 'antd';
import { brand } from './brand';

export const adminTheme: ThemeConfig = {
  token: {
    colorPrimary: brand.gold,
    colorInfo: brand.jaguar,
    colorSuccess: '#1f7a4d',
    colorWarning: '#8a6a1f',
    colorError: '#a4452f',
    colorLink: brand.jaguar,
    colorTextBase: brand.ink,
    colorBgLayout: brand.paper,
    colorBorder: brand.line,
    colorBorderSecondary: brand.cardLine,
    fontFamily: brand.fSans,
    borderRadius: 10,
    borderRadiusLG: 16,
    wireframe: false,
  },
  components: {
    Layout: {
      headerBg: '#ffffff',
      bodyBg: brand.paper,
      footerBg: brand.paper,
    },
    Menu: {
      itemColor: brand.sub,
      itemHoverColor: brand.navy900,
      itemSelectedColor: brand.navy900,
      itemSelectedBg: 'rgba(196,151,49,0.14)',
      itemBorderRadius: 9,
      fontSize: 14,
      groupTitleColor: brand.sub,
    },
    Button: {
      fontWeight: 700,
      primaryColor: brand.navy900, // navy text on the gold primary
      borderRadius: 10,
      controlHeight: 38,
    },
    Card: {
      borderRadiusLG: 16,
      colorBorderSecondary: brand.cardLine,
    },
    Table: {
      headerBg: brand.paper,
      headerColor: brand.sub,
      headerSplitColor: brand.line,
      borderColor: brand.cardLine,
      rowHoverBg: '#fafbfd',
      fontSize: 13,
    },
    Tag: {
      borderRadiusSM: 999,
      fontSizeSM: 11,
    },
    Input: { borderRadius: 10, controlHeight: 38 },
    Select: { borderRadius: 10, controlHeight: 38 },
    Statistic: { contentFontSize: 30 },
    Typography: { fontFamilyCode: 'monospace' },
  },
};
